module.exports = __webpack_public_path__ + "img/docCor.854b787f.png";